import React from "react";
import PredictionPage from "../../components/PredictionPage";

function AU200() {
  return (
    <PredictionPage
      title="AU200"
      content="This is the AU200 AI Trading Predictions page."
      canonical="/indices/au200-ai-trading-predictions"
      categoryKey="nav.indices"
      categoryPath="/indices"
      symbol="AU200"
    />
  );
}

export default AU200;
